module.exports = function (val) {
    return !!val
      && typeof val.length === 'number'
      && typeof val.callee === 'function'
    ;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/is-args/index.js
// module id = 1790
// module chunks = 29